export default {
  id: 'vitalSign/BLOOD_PRESSURE/v1',
  formSchema: {
    title: 'encounter:widget.vitalSigns.bloodPressure',
    type: 'object',
    required: ['id001', 'id002'],
    properties: {
      id001: {
        type: 'integer',
        title: 'encounter:widget.vitalSigns.bloodPressureSystolic',
        minimum: 1,
        maximum: 999
      },
      id002: {
        type: 'integer',
        title: 'encounter:widget.vitalSigns.bloodPressureDiastolic',
        minimum: 1,
        maximum: 999
      }
    },
    iconClass: 'icon-timer',
    measurement: 'max'
  },
  uiSchema: {
    id001: { 'ui:widget': 'customI18nNumericWidget' },
    id002: { 'ui:widget': 'customI18nNumericWidget' },
    'x-liveValidate': false,
    'x-customClass': 'vital-signs-widget',
    'x-cancelBtnSize': 'sm',
    'x-saveBtnSize': 'sm'
  }
};
